import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Button, Flex, List } from 'antd';
import { useNavigate } from 'react-router-dom';

import getEnvConfig from '../../../../../utils/config/env';
import { Shop, ShopProps } from '../service/shop.interface';
import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';
import { ShopCard } from './ShopCard';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import { useAppDispatch } from '../../../../../store';
import { setShopCurrent } from '../store/shopSlice';

interface Props {
    readonly data: PaginatedResponse<ShopProps>;
    readonly filters: Shop;
    readonly setFilters: Dispatch<SetStateAction<Shop>>;
    readonly loading?: boolean;
}
export const ShopList = ({ data, setFilters, filters, loading }: Props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const pagination = useMemo(
        () => dynamicPagination(filters, setFilters, data?.total, 'Магазинов'),
        [filters, setFilters, data?.total]
    );

    const viewShop = (shop: ShopProps) => {
        if (!shop) return;
        dispatch(setShopCurrent(shop));
        const route = shop.type === 1 || shop.type === 2 ? 'links' : 'products';
        navigate(`${getEnvConfig().PUBLIC_PATH}/shops/shop/${route}`);
    };

    return (
        <List
            loading={loading}
            pagination={pagination}
            dataSource={data?.items || []}
            renderItem={(item: ShopProps) => (
                <Flex key={item.id} style={{ marginBottom: 16 }}>
                    <ShopCard
                        readonly
                        shop={item}
                        loading={loading}
                        actions={
                            <Button
                                disabled={loading}
                                onClick={() => viewShop(item)}
                            >
                                Перейти в магазин
                            </Button>
                        }
                    />
                </Flex>
            )}
        />
    );
};
